import{_ as o}from"./_getNative.js";import{_ as r}from"./_root.js";var a=o(r,"Map");export{a as _};
